<template>
  <div>
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Modificar atributos do dentista
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="container-dados-dentista">
          <foto-avatar :foto-url="dentista.foto" class-avatar="imagem-dentista"/>
          <div class="mt-2">
            <span>Nome</span><br/>
            <label>{{ dentista.nome }}</label>
          </div>
          <div class="mt-2">
            <span>Cargo</span><br/>
            <label>{{ dentista.cargo }}</label>
          </div>
          <div class="mt-2">
            <color-select
                label-titulo="Cor de identificação"
                :cor-selecionada="dentistaInput.corIdentificacao"
                @atualizarCor="alterarCorIdentificacao"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="confirmarAlteracao" text>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes} from '@/core/constants'
import FotoAvatar from '@/views/components/FotoAvatar.vue'
import ColorSelect from '@/views/components/ColorSelect.vue'

export default {
    name: 'ModalDentistaAgenda',
    components: {ColorSelect, FotoAvatar},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        dentista: {
            type: Object,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 400
        }
    },
    data() {
        return {
            dentistaInput: {
                id: null,
                foto: null,
                nome: null,
                cargo: null,
                corIdentificacao: null
            },
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        this.setarDadosDentista()
    },
    methods: {
        setarDadosDentista() {
            this.dentistaInput = _.cloneDeep(this.dentista)
        },
        fecharModal() {
            this.model = false
            this.$emit('modalDentistaAcaoFechar')
        },
        alterarCorIdentificacao(novaCor) {
            this.dentistaInput.corIdentificacao = novaCor
        },
        async confirmarAlteracao() {

            const input = {
                dentistaId: this.dentistaInput.id,
                corIdentificacao: this.dentistaInput.corIdentificacao
            }

            this.setMensagemLoading('Alterando atributos do dentista...')
            await this.$store.dispatch(actionTypes.AGENDA.EDITAR_DETALHES_DENTISTA, input)
            this.mostrarNotificacaoSucessoDefault()
            this.model = false
            this.$emit('buscarListaDentistas')
        }
    }
}

</script>

<style scoped lang="stylus">

.container-dados-dentista
  margin-top 20px
  display flex
  flex-direction column

  span
    font-size 14px

  label
    font-size 16px
    font-weight bold
    color #5A5A5A

.imagem-dentista
  height 90px
  width 90px
  border-radius 50%
  border 2px solid #eee
  align-self center

</style>